import { DateHelper } from "shared/helpers/DateHelper";
import client from "network/client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { setNeedsReset } from "shared/auth/redux/authSlice";

export function fetchPlanCaseLogic(state, action) {
  let items = action.payload.items.slice(1, action.payload.items.length);
  let dueItems = action.payload.due_items;
  moveElapsedItems(items, dueItems, state.today);
  state.items = items;
  state.needsReload = false;
  state.dueItems = dueItems;
  state.status = "idle";
}

function moveElapsedItems(items, dueItems, today) {
  const elapsedItems = [];
  itemsToMove(items, today)
    .reverse()
    .forEach((item) => {
      if (item.action === "move") {
        elapsedItems.push(items[item.index]);
      }
      items.splice(item.index, 1);
    });
  dueItems.push(...elapsedItems.reverse());
}

function itemsToMove(items, today) {
  let duration = 0;
  const now = new Date();
  const currentTimeInMinutes = now.getHours() * 60 + now.getMinutes();
  let i = 0;
  let result = [];
  let item;
  let itemDay;
  while (i < items.length) {
    item = items[i];
    itemDay = DateHelper.parseDate(item.day);
    today = typeof today === "string" ? DateHelper.parseDate(today) : today;
    if (itemDay > today || typeof item.time_in_minutes !== "number") {
      break;
    } else if (itemDay.getTime() === today.getTime()) {
      duration = item.duration ? item.duration : 0;
      if (item.time_in_minutes + duration < currentTimeInMinutes) {
        if (item.type === "appointment") {
          result.push({ index: i, action: "remove" });
        }
        if (item.type === "task" && item.task_type === "critical") {
          result.push({ index: i, action: "move" });
        }
      }
    }
    i++;
  }
  return result;
}

// Thunk functions
export const fetchPlanThunkAction = createAsyncThunk(
  "itemLists/fetchPlanItems",
  async (unused, { getState, dispatch, rejectWithValue }) => {
    const get = client().get;
    const state = getState();
    const dateHelper = getDateHelper(state);
    try {
      const response = await get(
        "plan?today=" + dateHelper.getDateString(),
        state.auth.token
      );
      return response;
    } catch (error) {
      console.log("error in fetchPlanThunk: ", error);
      if (error.status === 401) {
        dispatch(setNeedsReset(true));
      }
      return rejectWithValue(error);
    }
  }
);

export const fetchDoneListThunkAction = createAsyncThunk(
  "itemLists/fetchDoneList",
  async (unused, { getState }) => {
    const state = getState();
    const dateHelper = getDateHelper(state);
    const get = client().get;
    const now = new Date().toString();
    const response = await get(
      "done_list?today=" + dateHelper.getDateString() + "&now=" + now,
      state.auth.token
    );
    return response;
  }
);

function getDateHelper(state) {
  return new DateHelper(DateHelper.parseDate(state.itemLists.today));
}
